import * as React from "react"

const RankingBox = ({
  number = "N/A",
  text = "Overall City Ranking",
  subtext = "",
  numberBgColor = "pfb-blue",
  boxType,
}) => {
  return (
    <div className="flex flex-col min-h-[5vh] items-stretch md:flex-row">
      <div
        className={`flex items-center justify-center w-full text-white text-[75px] font-dharma font-normal leading-[0.7] p-[25px_0] text-center md:w-[100px]`}
        style={{ backgroundColor: `${numberBgColor}` }}
      >
        {number}
      </div>
      <p
        className={`flex flex-col items-center justify-center w-full min-h-[100px] text-center text-white uppercase p-[10px_15px] m-0 md:items-start md:justify-center md:text-left md:p-[10px_25px] md:w-[calc(100%-100px)] ${
          boxType === "primary" ? "bg-pfb-navy" : "bg-pfb-gray"
        }`}
      >
        <span className="text-white text-[18px] leading-[1.3] m-[0_0_2px_0]">
          {text}
        </span>
        <span className="text-white text-[18px] leading-[1.3] m-[0_0_2px_0]">
          {subtext}
        </span>
      </p>
    </div>
  )
}

export default RankingBox
